import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../../core/shared/object/service/observer.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";

@Component({
    selector: 'te-blueprint-object-component-base',
    template: '',
    standalone: false
})
export class TeBlueprintObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    blueprintWidget: WidgetData;
    navigationItems: NavigationItem[];

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService) {
        super(route);
    }

    ngOnInit() {
        this.loadNavigationItems();
        super.ngOnInit();
        this.onObjectChanged();
        this.initialized = true;
    }

    onObjectChanged() {
        this.refreshBlueprintWidget();
    }

    loadNavigationItems() {
    }

    refreshBlueprintWidget() {
        this.blueprintWidget = WidgetFactory.createWidgetEntityData(
            'te.blueprint.widget.basic',
            'Blueprint',
            'te.TeTemplateBlueprint',
            this.objectIdentifier.objectId
        );
    }

    handleNavigationItemsChange(): void {
        this.onNavigationItems.emit(this.navigationItems);
    }
}
